import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="text-gray-600 body-font bg-[#2766be] fixed top-0 left-0 w-full shadow-xl z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-row items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img src="/img/logonew.png" className="w-14 h-14 rounded-full object-cover" alt="Logo" />
          <span className="ml-3 text-2xl text-white font-sans">Evo Team</span>
        </Link>

        {/* Menu - Desktop */}
        <nav className="hidden md:flex space-x-6 text-white text-lg">
          <Link to="/" className="hover:text-[#b1c6da] font-sans">Bosh Sahifa</Link>
          <Link to="/biz-haqimizda" className="hover:text-[#b1c6da] font-sans">Biz Haqimizda</Link>
          <Link to={'/loyihalarmiz'} className="hover:text-[#b1c6da] font-sans">Loyihalarmiz</Link>
          <Link to="/blog" className="hover:text-[#b1c6da] font-sans">Blog</Link>
          <Link to="/news" className="hover:text-[#b1c6da] font-sans">Yangliklar</Link>
          <Link to="/boglanish" className="hover:text-[#b1c6da] font-sans">Aloqa</Link>
        </nav>

        {/* Xizmatlar tugmasi */}
        <Link to='/xizmatlar' className="hidden md:flex items-center bg-gray-100 px-4 py-2 rounded hover:bg-[#b1c6da] font-sans">
          Xizmatlar
          <svg
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            className="w-4 h-4 ml-1"
            viewBox="0 0 24 24"
          >
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </Link>

        {/* Hamburger Menu */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-800 py-3">
          <nav className="flex flex-col items-center space-y-3 text-white text-lg">
            <Link to="/" onClick={() => setMenuOpen(false)}>Bosh Sahifa</Link>
            <Link to="/biz-haqimizda" onClick={() => setMenuOpen(false)}>Biz Haqimizda</Link>
            <Link to="/loyihalarmiz" onClick={() => setMenuOpen(false)}>Loyihalarmiz</Link>
            <Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link>
            <Link to="/yangliklar" onClick={() => setMenuOpen(false)}>Yangliklar</Link>
            <Link to="/boglanish" onClick={() => setMenuOpen(false)}>Aloqa</Link>
            <Link to='/xizmatlar' onClick={() => setMenuOpen(false)} className="bg-gray-100 px-4 py-2 rounded font-sans hover:bg-gray-200 text-gray-900">
              Xizmatlar
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;


